export const style = {
  toolbar: {
    position: `relative`,
    padding: `18px 18px 17px`,
    borderBottom: `2px solid #eee`,
    marginBottom: `20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Editor/style/toolbar.js